module.exports = __webpack_public_path__ + "img/trivia-listimg.8995b5da.jpg";